import { useState } from 'react'
import { useSelector } from 'react-redux'
import CircularProgress from '@material-ui/core/CircularProgress'

import { Alerts, ModalDel } from '~/components'

import SC from './styled.activity'
import FC from './factory-components.activity'
import AddEquipmentTaskModal from './add-task'
import AddTaskActivityChecklistModal from './add-task-checklist'
import AttachmentTaskActivityChecklistModal from './attachment-task-checklist'

import Funcs from './functions.activity'
import constants from './constants.activity'
import TallySheet from './tally-sheet/tally-sheet.main'

const ActivityModal = ({
  dataAll,
  dataSrCode,
  codeVessel,
  tallySheetModal,
  dataPlanArrival,
  getDataExecution,
  taskLevelOptions,
  toggleTallySheetModal,
}) => {
  const { Location: location } = dataAll

  const [task, setTask] = useState({})
  const [dataSort, setDataSort] = useState([])
  const [activity, setActivity] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const [notConfirm, setNotConfirm] = useState(false)
  const [openWarning, setOpenWarning] = useState(false)
  const [isInProgress, setIsInProgress] = useState(false)
  const [totalPercentage, setTotalPercentage] = useState(0)
  const [showModalStatus, setShowModalStatus] = useState(
    constants.showModalStatus
  )
  const [attachmentList, setAttachmentList] = useState(null)
  const [toggleDeleteManualTask, setToggleDeleteManualTask] = useState(false)
  const [isOpenModalTaskChecklist, setIsOpenModalTaskChecklist] = useState({
    isOpen: false,
    data: {}
  })
  const [isOpenModalTaskDocumentChecklist, setIsOpenModalTaskDocumentChecklist] = useState({
    task: {},
    isOpen: false,
    activity: {}
  })
  const [toggleDeleteChecklistTask, setToggleDeleteChecklistTask] = useState(false)

  const [showAlert, setShowAlert] = useState({
    msg: '',
    type: '',
    visible: false,
    success: false,
  })

  // If SR form is valid (user has filled all required fields), then user can tick the checkbox
  const { isValid } = useSelector(
    (state) => state.executionValidateSRFormReducer
  )
  const [activityList, setActivityList] = Funcs.useFetchActivityBySRCode(
    dataSrCode,
    setIsLoading,
    setTotalPercentage
  )

  const toggleModalTask = (data) => {
    setIsOpenModalTaskChecklist((prevState) => ({
      data: data,
      isOpen: !prevState.isOpen,
    }))
  }

  const toggleModalTaskAttachment = (mode = 'view', task, activity) => {
    setIsOpenModalTaskDocumentChecklist((prevState) => ({
      task: task,
      isOpen: !prevState.isOpen,
      activity: activity,
    }))

    // In view mode, reset with the current task's data
    if (mode === 'view') {
      setAttachmentList(task?.progress_task_attachment_list || null)
    }

    // In edit mode, persist current attachmentList if it already exists, otherwise load from task
    if (mode === 'edit') {
      setAttachmentList(attachmentList || task?.progress_task_attachment_list)
    }
  }

  // HOF: Higher order function will create the approriate function to use
  const form = Funcs.createForm(dataAll)
  const toggleModal = Funcs.toggleModalHOF(showModalStatus, setActivityList, setShowModalStatus)
  const updateActivity = Funcs.updateActivityHOF(setActivityList)
  const addNewTask = Funcs.addNewTaskHOF(setActivityList, location)
  const onDragEnd = Funcs.onDragEndHOF(activityList, setActivityList)
  const toggleEditMode = Funcs.toggleEditModeHOF(activityList, setActivityList, setAttachmentList)
  const handleOpenActivityDetail = Funcs.handleOpenActivityDetailHOF(
    activityList,
    setActivityList
  )
  const deleteTask = Funcs.deleteTaskHOF(
    setActivityList,
    location,
    activity,
    task,
    setToggleDeleteManualTask,
    setShowAlert
  )
  const updateActivityAndTaskHeader = Funcs.updateActivityAndTaskHeaderHOF(
    activityList,
    setActivityList,
    setIsLoading
  )
  const handleCheckProgressActivity = Funcs.handleCheckProgressActivityHOF(
    dataAll,
    dataSrCode,
    isInProgress,
    isValid,
    setShowAlert,
    setNotConfirm,
    setActivityList,
    dataPlanArrival,
    setOpenWarning,
    getDataExecution
  )
  const deleteChecklistTask = Funcs.deleteChecklistTaskHOF(
    setActivityList,
    location,
    activity,
    task,
    activityList,
    setToggleDeleteChecklistTask,
    setShowAlert
  )
  const updateChecklistTask = Funcs.updateActivityChecklistTaskHOF(
    dataAll,
    location,
    activityList,
    attachmentList,
    setActivityList,
    setShowAlert,
    setIsLoading,
    setAttachmentList,
  )
  const createChecklistTask = Funcs.createActivityChecklistTaskHOF(
    activityList,
    setActivityList,
    setShowAlert,
    toggleModalTask,
  )

  Funcs.checkIsInProgress(codeVessel, setIsInProgress)

  const handleRemoveManualTaskModal = () => (
    <div>
      <ModalDel
        id='m_actv_delete_manual_task_mdl'
        toggleDialog={() => setToggleDeleteManualTask(!toggleDeleteManualTask)}
        submitDelete={deleteTask}
        deleteText='Are you sure to delete the data ?'
      />
    </div>
  )

  const handleRemoveChecklistTakModal = () => (
    <div>
      <ModalDel
        id='m_actv_delete_checklist_task_mdl'
        deleteText='Are you sure to delete the data ?'
        toggleDialog={() => setToggleDeleteChecklistTask(!toggleDeleteChecklistTask)}
        submitDelete={deleteChecklistTask}
      />
    </div>
  )

  const deleteData = (activity, task) => {
    setTask(task)
    setActivity(activity)

    if (activity.activity_type === 'Manual') {
      setToggleDeleteManualTask(!toggleDeleteManualTask)
    } else {
      setToggleDeleteChecklistTask(!toggleDeleteChecklistTask)
    }
  }

  return (
    <SC.Container>
      {isLoading ? (
        <SC.CircularProgressWrapper>
          <CircularProgress />
        </SC.CircularProgressWrapper>
      ) : (
        <>
          {toggleDeleteManualTask && handleRemoveManualTaskModal()}
          {toggleDeleteChecklistTask && handleRemoveChecklistTakModal()}
          {tallySheetModal && (
            <TallySheet
              dataAll={dataAll}
              open={tallySheetModal}
              handleClose={toggleTallySheetModal}
            />
          )}
          <FC.TopForm form={form} />
          <FC.ActivityGrid
            location={location}
            onDragEnd={onDragEnd}
            attachmentList={attachmentList}
            addNewTask={addNewTask}
            activityList={activityList}
            taskLevelOptions={taskLevelOptions}
            setActivityList= {setActivityList}
            handleShowModal={toggleModal}
            updateActivity={updateActivity}
            toggleEditMode={toggleEditMode}
            toggleModalTask={toggleModalTask}
            deleteTask={deleteData}
            updateChecklistTask={updateChecklistTask}
            handleOpenActivityDetail={handleOpenActivityDetail}
            toggleModalTaskAttachment={toggleModalTaskAttachment}
            updateActivityAndTaskHeader={updateActivityAndTaskHeader}
            handleCheckProgressActivity={handleCheckProgressActivity}
            dataSort={dataSort}
            setDataSort= {setDataSort}
          />
        </>
      )}
      {showModalStatus.isOpen && (
        <AddEquipmentTaskModal
          srCode={dataSrCode}
          dataAll={dataAll}
          toggleModal={toggleModal}
          setShowAlert={setShowAlert}
          activityList={activityList}
          showModalStatus={showModalStatus}
        />
      )}
      {isOpenModalTaskChecklist.isOpen && (
        <AddTaskActivityChecklistModal
          data={isOpenModalTaskChecklist.data}
          toggleModal={toggleModalTask}
          taskLevelOptions={taskLevelOptions}
          createChecklistTask={createChecklistTask}
        />
      )}
      {isOpenModalTaskDocumentChecklist.isOpen && (
        <AttachmentTaskActivityChecklistModal
          task={isOpenModalTaskDocumentChecklist.task}
          activity={isOpenModalTaskDocumentChecklist.activity}
          location={location}
          attachmentList={attachmentList}
          toggleModal={toggleModalTaskAttachment}
          setShowAlert={setShowAlert}
          setAttachmentList={setAttachmentList}
          activityList={activityList}
          setActivityList={setActivityList}
        />
      )}

      {showAlert.visible && (
        <Alerts
          msg={showAlert.msg}
          type={showAlert.type}
          open={showAlert.visible}
          success={showAlert.success}
          close={() => {
            setShowAlert({ ...showAlert, visible: false })
          }}
        />
      )}

      {openWarning && (
        <FC.WarningModal
          dataAll={dataAll}
          notConfirm={notConfirm}
          openWarning={openWarning}
          isInProgress={isInProgress}
          setNotConfirm={setNotConfirm}
          setOpenWarning={setOpenWarning}
          totalPercentage={totalPercentage}
        />
      )}
    </SC.Container>
  )
}

export default ActivityModal
